export var IMarkerType;
(function (IMarkerType) {
    IMarkerType["topLeft"] = "topLeft";
    IMarkerType["topCenter"] = "topCenter";
    IMarkerType["topRight"] = "topRight";
    IMarkerType["bottomRight"] = "bottomRight";
    IMarkerType["bottomCenter"] = "bottomCenter";
    IMarkerType["bottomLeft"] = "bottomLeft";
    IMarkerType["leftCenter"] = "leftCenter";
    IMarkerType["rightCenter"] = "rightCenter";
    IMarkerType["rotation"] = "rotation";
})(IMarkerType || (IMarkerType = {}));
